const symbolHandlerSx = (theme) => ({
    buttonContainer: {
        marginBottom: '32px',
    },
    container: {
        width: '500px',
        height: '600px',
    },
    contentContainer: {
        padding: '8px',
    },
    symbolContainer: {
        height: 'calc(100% - 170px)',
        overflow: 'auto',
    },
    centerText: {
        textAlign: 'center',
    },
    compactModeButton: {
        width: 'calc(100% / 3 - 10px)',
        marginLeft: '5px',
        marginRight: '5px',
    },
    compactModeRow: {
        height: '60px',
        width: '100%',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    multiDialogCodeName: {
        fontSize: '0.8em',
        maxWidth: '350px',
        marginBottom: 0,
        paddingBottom: 0,
    },
});

export default symbolHandlerSx;
